import {inject, Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import {AppConfigService} from "@app/app-config.service";

interface ChatCompletionResponse {
  choices?: { message?: { content?: string } }[];
}

@Injectable({ providedIn: 'root' })
export class OpenAiService {
  //private readonly baseUrl = environment.openAiBaseUrl.replace(/\/$/, '');
  private cfg = inject(AppConfigService);
  constructor(private http: HttpClient) {}
  private get baseUrl(): string {
    return this.cfg.apiBaseUrl.replace(/\/$/, '');
  }

  async sendChatCompletion(userContent: string, systemPrompt?: string): Promise<string> {
    if (!environment.openAiApiKey) {
      throw new Error('OpenAI API-Schlüssel fehlt. Bitte in der environment-Konfiguration setzen.');
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${environment.openAiApiKey}`,
      'Content-Type': 'application/json'
    });

    const messages = [
      ...(systemPrompt ? [{ role: 'system', content: systemPrompt }] : []),
      { role: 'user', content: userContent }
    ];

    const body = {
      model: environment.openAiModel || 'gpt-5.1',
      messages,
      temperature: 0.2
    };

    const response = await firstValueFrom(
      this.http.post<ChatCompletionResponse>(`${this.baseUrl}/chat/completions`, body, { headers })
    );

    return response.choices?.[0]?.message?.content?.trim() || '';
  }
}
